import { createAction, createReducer } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  isAuthenticated: false,
  token: null,
  failed: false,
};

export const authAction = createAction<string>('@legadoPage/AUTH_ACTION');
export const unauthAction = createAction('@legadoPage/UNAUTH_ACTION');

const legadoAuthReducer = createReducer(INITIAL_STATE, {
  [authAction.type]: (state, action) => ({
    ...state,
    isAuthenticated: true,
    token: action.payload,
  }),
  [unauthAction.type]: (state) => ({
    ...state,
    isAuthenticated: false,
  }),
});

export default legadoAuthReducer;
